import { render, staticRenderFns } from "./PostSuccess.vue?vue&type=template&id=9032b81c&scoped=true&"
import script from "./PostSuccess.vue?vue&type=script&lang=js&"
export * from "./PostSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PostSuccess.vue?vue&type=style&index=0&id=9032b81c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9032b81c",
  null
  
)

export default component.exports